export var SupplyDemandZoneSide;
(function (SupplyDemandZoneSide) {
    SupplyDemandZoneSide["demand"] = "demand";
    SupplyDemandZoneSide["supply"] = "supply";
})(SupplyDemandZoneSide || (SupplyDemandZoneSide = {}));
export var SupplyDemandPatternKind;
(function (SupplyDemandPatternKind) {
    SupplyDemandPatternKind["dropBaseRally"] = "dropBaseRally";
    SupplyDemandPatternKind["rallyBaseRally"] = "rallyBaseRally";
    SupplyDemandPatternKind["rallyBaseDrop"] = "rallyBaseDrop";
    SupplyDemandPatternKind["dropBaseDrop"] = "dropBaseDrop";
})(SupplyDemandPatternKind || (SupplyDemandPatternKind = {}));
export var SupplyDemandZoneStatus;
(function (SupplyDemandZoneStatus) {
    SupplyDemandZoneStatus["active"] = "active";
    SupplyDemandZoneStatus["fullyMitigated"] = "fullyMitigated";
    SupplyDemandZoneStatus["invalidated"] = "invalidated";
})(SupplyDemandZoneStatus || (SupplyDemandZoneStatus = {}));
export var SupplyDemandEventType;
(function (SupplyDemandEventType) {
    SupplyDemandEventType["demandCreated"] = "demandCreated";
    SupplyDemandEventType["supplyCreated"] = "supplyCreated";
    SupplyDemandEventType["demandFirstTouch"] = "demandFirstTouch";
    SupplyDemandEventType["supplyFirstTouch"] = "supplyFirstTouch";
    SupplyDemandEventType["demandMidpointTouched"] = "demandMidpointTouched";
    SupplyDemandEventType["supplyMidpointTouched"] = "supplyMidpointTouched";
    SupplyDemandEventType["demandFullyMitigated"] = "demandFullyMitigated";
    SupplyDemandEventType["supplyFullyMitigated"] = "supplyFullyMitigated";
    SupplyDemandEventType["demandInvalidated"] = "demandInvalidated";
    SupplyDemandEventType["supplyInvalidated"] = "supplyInvalidated";
})(SupplyDemandEventType || (SupplyDemandEventType = {}));
//# sourceMappingURL=SupplyDemandAnalyzerTypes.js.map